module.exports = __webpack_public_path__ + "static/media/theatrebolshoi.99bfd451.jpg";